import { render, staticRenderFns } from "./topmenu.vue?vue&type=template&id=f6e9fbf8"
import script from "./topmenu.ts?vue&type=script&lang=js&external"
export * from "./topmenu.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6e9fbf8')) {
      api.createRecord('f6e9fbf8', component.options)
    } else {
      api.reload('f6e9fbf8', component.options)
    }
    module.hot.accept("./topmenu.vue?vue&type=template&id=f6e9fbf8", function () {
      api.rerender('f6e9fbf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/topmenu/topmenu.vue"
export default component.exports